import React from "react";
import { Box } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import moment from "moment";

const NoSubscriptionBanner = ({
  t,
  role,
  hasTrial,
  redirectToSelectedPack,
  userCreatedAt,
  classes,
  onOpenCustomCreation,
}) => {
  if (role === "PACK_ESSAIE") {
    const expiryDate = moment(userCreatedAt).add(7, "days").format("DD/MM/YYYY");
    return (
      <Box>
        <Box className={classes.banner}>
          {t("no_subscribtion.trial_expiry", { date: expiryDate })}
          <Box component="span" style={{ display: "block", fontSize: 13, fontWeight: 400, marginTop: 4, opacity: 0.9 }}>
            {t("no_subscribtion.custom_creation")}{" "}
            <span
              onClick={onOpenCustomCreation}
              style={{ color: "white", textDecoration: "underline", cursor: "pointer" }}
            >
              {t("no_subscribtion.contact_us")}
            </span>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      {(role === "NO_SUBSCRIBTION" || role === "NEW_MEMBER") && (
        <Box className={classes.banner}>
          {redirectToSelectedPack ? (
            <>
              {hasTrial
                ? t("no_subscribtion.text_trial")
                : t("no_subscribtion.text")}{" "}
              .
            </>
          ) : (
            <>
              {hasTrial
                ? t("no_subscribtion.text_trial")
                : t("no_subscribtion.text")}{" "}
              <a style={{ color: "white" }} href="/subscribe">
                {t("no_subscribtion.here")}
              </a>
              .
            </>
          )}
        </Box>
      )}
    </Box>
  );
};

export default withTranslation()(NoSubscriptionBanner);
